export default {
  list: [],
  templateList: [],
  store: null,
  iframeSrc: '',
  apparelSizes: [],
};
